<template>
  <b-form-group>
    <Multiselect
      v-model="theme"
      placeholder="Theme"
      track-by="id"
      label="name"
      :options="themeOptions"
      :allow-empty="false"
      @input="onInput"
    />
  </b-form-group>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import { ThemesContainerSingleton } from '@/banner_template/themes/ThemesContainerSinglton';
import {ShowPageScopeCollector} from "@frontend/group/modules/scope-collectors/show-page-collector";

export default {
  name: 'ThemeModule',
  components: {
    Multiselect,
  },
  data: () => ({
    selectedTheme: null,
    themeOptions: []
  }),
  computed: {
    ...mapGetters('layout', [
      'selectedInstance',
    ]),
    theme: {
      get () {
        return _.find(this.themeOptions, ['id', this.selectedInstance.data.theme])
      },
      set (val) {
        this.selectedTheme = val
        window.selectedTheme = val
      },
    },
  },
  mounted() {
    this.getThemesOptions();
  },
  methods: {
    async getThemesOptions() {
      const { data } = await axios.get(
          window.location.origin
          + `/banner/get-template-themes?instance_id=${this.selectedInstance.id}`
          + `&layout_id=${$("#template-group-preview").attr("data-layout-id")}`
      );
      this.themeOptions = data;
    },
    onInput() {
      const { updateLayoutChanges } = ShowPageScopeCollector.get([
        'updateLayoutChanges',
      ]);

      updateLayoutChanges(this.selectedInstance.id, 'theme', this.selectedTheme.id);
    }
  }
}
</script>

<style scoped lang="scss">

</style>
